import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { initAmplifyAuth } from '@lp/core/auth';
import { getRouter } from '@lp/core/routing';
import { initSentry } from '@/sentry';
import { ENABLE_API_MOCK } from '@/constants/env.constants';

import { App } from './app';

// TODO: maybe move react-toastify to design system
import './index.css';

const initApp = async () => {
  if (ENABLE_API_MOCK !== 'true') {
    return true;
  }

  const { enableApiMocking } = await import('@mocks/api.mock');
  const mockService = await enableApiMocking();

  return mockService?.active?.state === 'activated';
};

initApp().then(async () => {
  await initAmplifyAuth();
  initSentry();

  const rootNode = document.getElementById('root');

  const router = getRouter();

  if (rootNode) {
    ReactDOM.createRoot(rootNode).render(
      <StrictMode>
        <App router={router} />
      </StrictMode>,
    );
  }
});
